import React, {  } from 'react'
import ReactDOM from 'react-dom'
import Video from '@Components/article/video/Video';
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

const Index = (({ title }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <div style={{ marginTop: '20px' }}>
        <Video title={title} />
      </div>
    </QueryClientProvider >
  )
})

export default Index;